/** Placeholder. The Vegetation agent adds instanced foliage with wind. */
export class VegetationSystem { async init(ctx) { ctx.vegetation = {}; } }
